var BlockSize = {
    Large:3,
    Medium:2,
    Small:1
};

export default BlockSize;
